<script>
    import{flow_steps, user_data, userNotification} from './stores.js';
    import { onMount } from "svelte";
    import Iqtemplate from "./components/iqtemplate.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';
    import {link, location, push, pop, replace} from 'svelte-spa-router';
    import Cleave from 'cleave.js';    

    let first_name_element;
    let last_name_element;
    let mobile_phone_element;
    let email_element;
    let address_element;
    let user_address;
    let city_element;
    let zipcode_element;
    let state_element;

    let first_name_error = "";
    let last_name_error = "";
    let mobile_phone_error = "";
    let email_error = "";


    function showProgress() {
        NProgress.start();
    }

    function doSaveInfo(search_data){
        // if($flow_steps.current_flow.startsWith("i")) {
        //     search_data["cid"] = "219";
        // }else{
        //     search_data["cid"] = "222";
        // }
        showProgress();
        superagent
        .post('/api/obapi')
        .send({ action: 'addlead', search_data: search_data }) // sends a JSON post body
        .set('accept', 'json')
        .end((err, res) => {
            if(err !== null){
                userNotification('error', 'Error:', err.toString());
                // show_overlay = false;
                NProgress.done();
            }else{
// console.log(res.text)
                res = JSON.parse(res.text);
                if(!res.st){
                    userNotification('error', 'Error:', res.msg);
                    // show_overlay = false;
                    NProgress.done();

                }else{
                    // clearTimeout(step1);
                    // clearTimeout(step2);
                    // showText("...You're all set!");
                    // setTimeout(() => {
                    //     showText("...we'll be in touch shortly.");
                    // }, 2000);
                    setTimeout(() => {
                        // show_overlay = false;
                        NProgress.done();
                        // callback();
                        push('#/thank_you');
                        // $emitter.emit('progressClick', '');
                    }, 4000);

                }
            }
        });        

    }

    function doValidate(){
        let res = true;

        if(first_name_element.value.trim().length < 1){
            first_name_error = "First name is required";
            res = false;
        }

        if(last_name_element.value.trim().length < 1){
            last_name_error = "Last name is required";
            res = false;
        }
        if(mobile_phone_element.value.trim().length < 1){
            mobile_phone_error = "Contact number is required";
            res = false;
        }
        if(email_element.value.trim().length < 1){
            email_error = "Contact email is required";
            res = false;
        }

        return res;        
    }

    function doSubmitToVelocify(){
        if(doValidate() === true){
            let search_data = {};
            search_data["cid"] = '228';
            search_data["credit_score"] = $user_data.creditscore;
            search_data["credit_fico"] = $user_data.creditscore;
            search_data["first_time_home_buyer"] = ($user_data['firsttimebuyer']) ? "Yes" : "No";
            search_data["property_type"] = $user_data.propertytype;
            search_data["first_name"] = $user_data.firstname;
            search_data["last_name"] = $user_data.lastname;
            search_data["phone_number"] = $user_data.mobilephone;
            search_data["email"] = $user_data.email;
            search_data["best_contact_method"] = $user_data.bestcontactmethod;
            search_data["best_time"] = $user_data.bestcontacttime;
            doSaveInfo(search_data);
            console.log(search_data);

        }


    }

    function clearFunction() {
        first_name_error = "";
        last_name_error = "";
        mobile_phone_error = "";
        email_error = "";
    }

    onMount(async() => {
        mobile_phone_formatter = new Cleave(mobile_phone_element, {
            numericOnly: true,
            blocks: [0, 3, 0, 3, 4],
            delimiters: ["(", ")", " ", "-"]
        });

    });

</script>

<Iqtemplate
    top_container_background={false}
>

<div class="cszinputcontainer">
    

    <div class="cszinputfieldcontainer">
        <div class="badgecontainer"><img src="/img/Banner-01.png" alt="Congrats!"></div>
        <div class="progresstext">6/6</div>

        {#if $user_data.does_qualify === true}
        <div class="main-title">Congratulations! You qualify!</div>
        <div class="thankyoucopy">You meet the criteria to qualify for our Semper Elevate down payment program.
            Please submit your contact information and we can get started
            working together!</div>
        {:else}
        <div class="main-title">Congratulations!</div>
        <div class="thankyoucopy">Although you do not meet the criteria for our Semper Elevate down payment program, you do qualify for many other 
            programs we have available.</div>
        {/if}


            <div class="formcontainer">
                <div class="csztopcopy">Tell us about yourself</div>
                <!-- <div class="thankyoucopy">We will use this information to review the details of your home and reach out at a time that's convenient for you.</div> -->

                <div class="multipleformrow">
                    <div class="formrow">
                        <div class="formrowlabel">First name</div>
                        <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:this={first_name_element} bind:value={$user_data.firstname} type="text" /></div>
                        <div class="formrowerror">{first_name_error}</div>
                    </div>
                    <div class="formrow">
                        <div class="formrowlabel">Last name</div>
                        <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:this={last_name_element} bind:value={$user_data.lastname} type="text" /></div>
                        <div class="formrowerror">{last_name_error}</div>
                    </div>
    
                </div>

                <div class="multipleformrow">
                    <div class="formrow">
                        <div class="formrowlabel">Mobile phone</div>
                        <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:this={mobile_phone_element} bind:value={$user_data.mobilephone} type="text" /></div>
                        <div class="formrowerror">{mobile_phone_error}</div>
                    </div>
                    <div class="formrow">
                        <div class="formrowlabel">Email</div>
                        <div class="formrowinput"><input on:keyup={()=>{clearFunction();}} bind:this={email_element} bind:value={$user_data.email} type="text" /></div>
                        <div class="formrowerror">{email_error}</div>
                    </div>
                </div>
                <div class="multipleformrow">
                    <div class="formrow">
                        <div class="formrowlabel">Best contact method</div>
                        <div class="formrowinput"><select bind:value={$user_data.bestcontactmethod}><option></option><option>Email</option><option>Phone</option></select></div>
                    </div>
                    <div class="formrow">
                        <div class="formrowlabel">Best time to contact</div>
                        <div class="formrowinput"><select bind:value={$user_data.bestcontacttime}><option></option><option>Afternoon</option><option>Morning</option><option>Evening</option></select></div>
                    </div>
                </div>
        
        
            </div>            
            
            <div class="buttoncontainer">
                <div class="progressbuttonholder">
                    <button on:click={()=>{pop();}} class="backbutton"><span class="backarrowcontainer"><img src="/img/triangle-left-arrow.svg" alt="back arrow" /></span>Go Back</button>
                </div>
                <div class="progressbuttonholder"><button on:click={()=>{doSubmitToVelocify();}} class="darken">Submit</button></div>
            </div>

    </div>
</div>


</Iqtemplate>

<style>
.main-title {
    font-size: 2.5em !important;
    font-weight: 700;
}
.thankyoutext {
    font-size: 1.5em;
    margin-top: 50px;
}
.thankyoucopy {
   margin-top: 20px;
   color: #657680;
   max-width: 400px;
   text-align: center;
}
.buttoncontainer {
    margin-top: 40px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.formcontainer .csztopcopy {
    padding-bottom: 20px;
}
@media (max-device-width: 1024px), (max-width: 1023px) {
    .buttoncontainer {
        flex-direction: column-reverse
    }
    .thankyoucopy {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
    }

}
</style>